import * as yup from 'yup'

const schema = yup.object().shape({
  label: yup.string().max(80, 'O rótulo deve ter no máximo 80 caracteres'),
  placeholder: yup
    .string()
    .max(80, 'O texto de exemplo deve ter no máximo 80 caracteres'),
  helpText: yup
    .string()
    .max(80, 'O texto de ajuda deve ter no máximo 80 caracteres'),
})

export default schema
